<template>
    <ColorPicker transfer v-model="color" alpha class="color-wrapper"/>
</template>
<script>
export default {
    props:["value"],
    data() {
        return {
            color: "red"
        }
    },
    watch: {
        value:{
            handler(v){
                if(v){
                    this.color = v;
                }
            },
            immediate: true
        },
        color:{
            handler(v){
                if(v){
                    this.$emit("input", this.color);
                    this.$emit("save");
                }
            },
            immediate:true
        }
    },
}
</script>
<style lang="less">
.ivu-select-dropdown.ivu-transfer-no-max-height {
    width: 268px;
}
</style>